<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import usuarioSelect from '~/graphql/usuarioSelect.graphql';
import alterarPastaForm from '~/graphql/alterarPastaForm.graphql';

interface Props
{
  compromisso?: any
  pastaCodigos?: string[]
  mostrarTodos?: boolean
  mostrarCampos?: string[]
}

const props = withDefaults(defineProps<Props>(), {
  mostrarTodos: true,
});

const emit = defineEmits(['close', 'loaded', 'success', 'error']);

const skipQuery = computed(() =>
{
  if (props.pastaCodigos?.length === 1)
  {
    return false;
  }

  if (props.compromisso)
  {
    return false;
  }

  return true;
});

const collapsesAtivos = ref([
  'dadosPasta',
  'clientePrincipal',
  'dadosProcessoJudicial',
  'dadosAjuizamento',
  'andamentoProcessual',
  'andamentoApreensao',
  'dadosVeiculo',
  'dadosAcordo',
  'dadosCrmDeepCenter',
]);

async function preSubmit(model: any)
{
  model.gerenteNegocialResponsavelCodigo = model.gerenteNegocialResponsavel?.value;
  return true;
}

onMounted(() =>
{
  emit('loaded');
});
</script>

<template>
  <GqlView
    :query="alterarPastaForm"
    :variables="{
      compromissoCodigo: props.compromisso ? props.compromisso.codigo : null,
      pastaCodigo: props.pastaCodigos?.length === 1 ? props.pastaCodigos[0] : null,
    }"
    :skip="skipQuery"
  >
    <template #success="{ data }: {data: any}">
      <CompromissoCommandForm
        command="AlterarPastaCompromissoCommand"
        :show-upload-files="true"
        :show-job-progress="false"
        :initial-model="
          {
            ...data?.model ?? {},
            ...{
              compromissoCodigos: props.compromisso ? [props.compromisso.codigo] : null,
              pastaCodigos: props.pastaCodigos,
            },
          }"
        :pre-submit="preSubmit"
        @close="() => emit('close')"
      >
        <template #form="{ model }">
          <a-collapse v-model:active-key="collapsesAtivos">
            <a-collapse-panel
              key="dadosPasta"
              header="DADOS DA PASTA"
            >
              <a-form-item
                v-if="props.mostrarTodos || props.mostrarCampos?.includes('gerenteNegocialResponsavel')"
                name="gerenteNegocialResponsavel"
              >
                <template #label>
                  <slot name="formItemLabel">
                    Gerente negocial responsável
                  </slot>
                </template>
                <GqlSelect
                  v-model:value="model.gerenteNegocialResponsavel"
                  :query="usuarioSelect"
                  placeholder="Selecione o gerente negocial responsável"
                  :allow-clear="true"
                  :variables="{ where: { ativo: { eq: true } } }"
                />
              </a-form-item>
            </a-collapse-panel>
          </a-collapse>
        </template>
      </CompromissoCommandForm>
    </template>
  </GqlView>
</template>
